import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ClickAwayListener, Tooltip } from '@mui/material';
import React, { useState } from 'react';

// CP-8222: MUI Tooltip only opens on hover/focus, and a bare SVG with no click
// handler gets no emulated mouse events on iOS — so plain <Tooltip><Icon/></Tooltip>
// info icons are dead on touch screens. Controlled tooltip: tap/click opens,
// tap-away closes; desktop hover still works via onOpen/onClose.
// disableTouchListener stops the built-in long-press handler's leaveTouchDelay
// timer from auto-closing a tap-opened tip.
//
// Lifted out of settings/AIMetricsTab.js for CP-8309 (Trip "Internal Name" help
// icon). Use this anywhere an info icon needs a tooltip; don't add new bare
// <Tooltip><InfoOutlinedIcon/></Tooltip> pairs.
export default function InfoTip({ title, sx, placement }) {
    const [open, setOpen] = useState(false);
    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Tooltip
                arrow
                title={title}
                placement={placement}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                disableTouchListener
            >
                <InfoOutlinedIcon onClick={() => setOpen(true)} sx={{ cursor: 'pointer', ...sx }} />
            </Tooltip>
        </ClickAwayListener>
    );
}
